import React from 'react'
import { IonRow, IonCol, IonButton, IonIcon, IonLabel, IonItem, IonChip } from '@ionic/react'
import { AccordianComponent } from '../../../components/accordian/Accordian.components'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { IOption, IPNNVOption } from '../../../common/common.types'
import {
  setFallHeight,
  setFallsurface,
  setInjurycause,
  setIntentional,
  setLandedon,
  setMechanism,
  setMechanismPNNV,
  setSafetyEquipment,
  setSafetyEquipmentPNNV,
  setTraumaCriteriaModerateRiskPNNV,
  setTraumaTriageCriteriaHighRiskPNNV,
  setTraumaTriageCriteriaModerateRisk,
  setTraumatriageCriteriaHighRisk,
  setWorkRelatedPNNV,
  setWorkrelated,
} from '../store/ccHpi.actions'
import MultiSelect from '../../../components/multiSelect/MultiSelect.component'
import NumberPad from '../../../components/numberPad/NumberPad.component'
import { getCcHpiOptionsSelector } from '../../options/selectors'
import { numberPadKeysWithDecimal } from '../../../components/numberPad/NumberPad.types'
import { getTripInformationSelector } from '../../tripInformation/selectors/tripInformation.selector'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { IDataPointsConfig } from '../../configurations/store/configurations.types'
import { getCcHpiInjuryDetailsSelector } from '../selectors/injuryDetails.selector'
import { addCircleOutline, checkmarkSharp, closeCircleOutline } from 'ionicons/icons'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useHistory } from 'react-router'
import { CcHpiConstants } from '../store/ccHpi.constants'
import Validation from '../../../components/validation/Validation.component'

const InjuryDetails: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const injuryDetailsState = useSelector(getCcHpiInjuryDetailsSelector)
  const {
    intentional,
    traumaTriageCriteriaHighRisk,
    traumaTriageCriteriaHighRiskPNNV,
    traumaTriageCriteriaModerateRisk,
    traumaTriageCriteriaModerateRiskPNNV,
    injurycause,
    mechanism,
    mechanismPNNV,
    safetyEquipment,
    safetyEquipmentPNNV,
    fallHeight,
    fallsurface,
    landedon,
    workrelated,
    workrelatedPNNV,
  } = injuryDetailsState
  const cchpiOptionsState = useSelector(getCcHpiOptionsSelector)
  const {
    intentionalOptions,
    traumaTriageCriteriaModerateRiskOptions,
    traumaTriageCriteriaHighRiskOptions,
    mechanismOptions,
    safetyEquipmentOptions,
    fallsurfaceOptions,
    landedonOptions,
    workrelatedOptions,
  } = cchpiOptionsState
  const tripInformationState: ITripInformationState = useSelector(getTripInformationSelector)
  const { patientCategory } = tripInformationState

  const dataPointsConfig: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_INJURY } = dataPointsConfig

  const hasInjuryDetailsData = () => {
    if (
      intentional ||
      traumaTriageCriteriaHighRisk?.length > 0 ||
      traumaTriageCriteriaHighRiskPNNV ||
      traumaTriageCriteriaModerateRisk?.length > 0 ||
      traumaTriageCriteriaModerateRiskPNNV ||
      injurycause?.length > 0 ||
      mechanism?.length > 0 ||
      mechanismPNNV ||
      safetyEquipment?.length > 0 ||
      safetyEquipmentPNNV ||
      fallHeight ||
      fallsurface ||
      workrelated ||
      workrelatedPNNV ||
      landedon
    )
      return true
    return false
  }

  const setIntetionalOnChange = (option: IOption) => {
    dispatch(setIntentional(option))
  }

  const setFallHeightOnChange = (numbers: string[]) => {
    dispatch(setFallHeight(numbers.join('')))
  }

  const setFallsurfaceOnChange = (option: IOption) => {
    dispatch(setFallsurface(option))
  }

  const setLandedonOnChange = (option: IOption) => {
    dispatch(setLandedon(option))
  }

  const setWorkrelatedOnChange = (option: IOption) => {
    dispatch(setWorkrelated(option))
  }

  const setWorkrelatedPNNVOnChange = (option: IPNNVOption) => {
    dispatch(setWorkRelatedPNNV(option))
  }

  const showInjuryCauseOptions = () => {
    history.push(TabConstants.CC_HPI_INJURY_CAUSE)
  }

  const removeInjuryCauseChip = (option: IOption) => {
    const filteredOptions = injurycause.filter((op: IOption) => op.id !== option.id)
    dispatch(setInjurycause(filteredOptions))
  }

  const injuryDetailsContent = (
    <>
      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='Intentional'
            options={intentionalOptions}
            selectedOption={intentional}
            listHeader={t('ccHpi.intentional')}
            label={t('ccHpi.intentional')}
            action={setIntetionalOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='TraumatriageCriteriaHighRisk'
            label={t('ccHpi.traumaTriageCriteriaHighRisk')}
            listHeader={t('ccHpi.traumaTriageCriteriaHighRisk')}
            options={traumaTriageCriteriaHighRiskOptions}
            savedValues={traumaTriageCriteriaHighRisk}
            action={setTraumatriageCriteriaHighRisk}
            savedPNNVValue={traumaTriageCriteriaHighRiskPNNV}
            pnnvAction={setTraumaTriageCriteriaHighRiskPNNV}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='TraumaTriageCriteriaModerateRisk'
            label={t('ccHpi.traumaTriageCriteriaModerateRisk')}
            listHeader={t('ccHpi.traumaTriageCriteriaModerateRisk')}
            options={traumaTriageCriteriaModerateRiskOptions}
            savedValues={traumaTriageCriteriaModerateRisk}
            action={setTraumaTriageCriteriaModerateRisk}
            savedPNNVValue={traumaTriageCriteriaModerateRiskPNNV}
            pnnvAction={setTraumaCriteriaModerateRiskPNNV}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />

      <IonRow id='Injurycause'>
        <IonButton
          data-testid='Injurycause'
          className='transform-none'
          fill='clear'
          color='primary-alt'
          onClick={showInjuryCauseOptions}>
          <IonIcon icon={addCircleOutline} />
          <IonLabel>{t('ccHpi.injurycause')}</IonLabel>
        </IonButton>
        {injurycause.length > 2 && <IonIcon color='success' className='checkmark-icon' icon={checkmarkSharp} />}
      </IonRow>
      {injurycause.length > 0 && injurycause.length < 3 && (
        <IonItem lines='none'>
          <IonRow className='ion-nowrap no-flex-shrink' id='List-Row'>
            {injurycause.map((option: IOption) => (
              <IonChip
                data-testid={`Chip${option.id}`}
                key={`Chip_${option.id}${option.name}`}
                className='lookup-search-chips custom-background'>
                <IonLabel>{option.name}</IonLabel>
                <IonIcon color='white' icon={closeCircleOutline} onClick={() => removeInjuryCauseChip(option)} />
              </IonChip>
            ))}
          </IonRow>
        </IonItem>
      )}
      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='Mechanism'
            label={t('ccHpi.mechanism')}
            listHeader={t('ccHpi.mechanism')}
            options={mechanismOptions}
            savedValues={mechanism}
            action={setMechanism}
            savedPNNVValue={mechanismPNNV}
            pnnvAction={setMechanismPNNV}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='SafetyEquipment'
            label={t('ccHpi.safetyEquipment')}
            listHeader={t('ccHpi.safetyEquipment')}
            options={safetyEquipmentOptions}
            savedValues={safetyEquipment}
            action={setSafetyEquipment}
            savedPNNVValue={safetyEquipmentPNNV}
            pnnvAction={setSafetyEquipmentPNNV}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <NumberPad
            elementId='FallHeight'
            dataTestId='fallHeight'
            values={fallHeight ? fallHeight.split('') : []}
            label={t('ccHpi.fallHeight')}
            onNumPadClick={setFallHeightOnChange}
            validCharacters={numberPadKeysWithDecimal}
          />
          <Validation id={CcHpiConstants.SET_FALL_HEIGHT} />
        </IonCol>
      </IonRow>

      <hr className='field-divider' />

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='Fallsurface'
            options={fallsurfaceOptions}
            selectedOption={fallsurface}
            listHeader={t('ccHpi.fallsurface')}
            label={t('ccHpi.fallsurface')}
            action={setFallsurfaceOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='Landedon'
            options={landedonOptions}
            selectedOption={landedon}
            listHeader={t('ccHpi.landedon')}
            label={t('ccHpi.landedon')}
            action={setLandedonOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='WorkRelated'
            options={workrelatedOptions}
            selectedOption={workrelated}
            listHeader={t('ccHpi.workrelated')}
            label={t('ccHpi.workrelated')}
            action={setWorkrelatedOnChange}
            selectedPNNVOption={workrelatedPNNV}
            pnnvAction={setWorkrelatedPNNVOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>
    </>
  )
  return (
    <>
      {((DP_INJURY === 1 && Boolean(patientCategory?.show_injdetails)) || hasInjuryDetailsData()) && (
        <IonRow>
          <IonCol className='ion-no-padding'>
            <AccordianComponent
              dataTestId='InjuryDetails'
              heading={t('ccHpi.injuryDetails')}
              content={injuryDetailsContent}
              isCheckMark={hasInjuryDetailsData()}
            />
            <hr className='field-divider' />
          </IonCol>
        </IonRow>
      )}
    </>
  )
}

export default InjuryDetails
